import React from 'react';

import { type CardChainIconProps } from '@pkg/components';

import { CollectionChainType } from '@app/client';

// TODO: These icons should utilitze `<CurrencyIcon />`.
import AptosLight from './icons/aptos-light.svg';
import AptosSvg from './icons/aptos.svg';
import EthereumLight from './icons/eth-light.svg';
import EthereumSvg from './icons/ethereum.svg';
import PolygonLight from './icons/polygon-light.svg';
import PolygonSvg from './icons/polygon.svg';

import { Wrapper } from './styles';

export const CardChainIcon = ({ chain = CollectionChainType.Ethereum, variant = 'primary' }: CardChainIconProps) => {
    return (
        <Wrapper $variant={variant}>
            {chain === CollectionChainType.Polygon && (
                <img alt="poligon icon" src={variant === 'light' ? PolygonLight : PolygonSvg} title="Polygon" />
            )}

            {chain === CollectionChainType.Aptos && (
                <img alt="aptos icon" src={variant === 'light' ? AptosLight : AptosSvg} title="Aptos" />
            )}

            {chain === CollectionChainType.Ethereum && (
                <img alt="ethereum icon" src={variant === 'light' ? EthereumLight : EthereumSvg} title="Ethereum" />
            )}
        </Wrapper>
    );
};
